import React from "react";

const CardFooter = (props) => {
  return (
    <div
      onClick={() => {
        window.open(
          props.link,
          "_blank"
        );
      }}
      className="group cursor-pointer flex text-center py-8 mb-4 flex-col justify-center items-center px-2 max-w-80 bg-white hover:bg-secondary-light rounded-lg border border-vp-raspberry w-full xl:w-1/4"
    >
      <img src={props.logo} alt="" className="mb-2.5" />
      <h4 className="font-bold text-xl mb-1 px-3">
        {props.title}
      </h4>
      <div className="3xl:text-lg text-vp-lightBlack opacity-0 group-hover:opacity-100 mb-2.5">
        {props.productBy}
      </div>
      <div className="text-sm font-semibold">{props.subtitle}</div>
    </div>
  );
};

export default CardFooter;
